import React, { useEffect, useState } from "react";
import { User } from "../types/User";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/LoginPage.css";
import logo from "../assets/logo.png";
import { useAuth } from "../context/AuthContext";
import CollecteLoadingMessage from "../components/CollecteLoadingMessage";
import { useNavigate } from "react-router-dom";
import ResetPasswordPopup from "../components/ResetPasswordPopup";

const LoginPage: React.FC = () => {
  const [formUser, setFormUser] = useState<User>({
    id: 0,
    nom: "",
    prenom:"",
    telephone: "",
    role: "",
    statut: "actif",
    email: "",
    username: "",
    password: ""
  });
  const { login, user } = useAuth();
  const navigate=useNavigate();
  const [showResetPopup, setShowResetPopup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormUser({ ...formUser, [e.target.name]: e.target.value });
    setErrorMessage("");
  };

  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoading(true);
    try {
      const result = await login(formUser.email, formUser.password);
      if (result.success) {
        setErrorMessage("");
      } else {
        setErrorMessage("Identifiant ou mot de passe incorrect.");
      }
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    if (user) {
      navigate("/"+user.landingPage);
    }
  }, [user]);  

  return (
    <div className="container-fluid login-page">
      <CollecteLoadingMessage visible={loading} message="Connexion en cours..." />
      {/* Bouton Retour */}
      <button 
        className="btn-back-top-left"
        type="button"
        onClick={() => navigate("/")}
      >
        <i className="bi bi-arrow-left"></i>
        <span>Retour au site</span>
      </button>
      <div className="row min-vh-100">
        {/* Colonne gauche */}
        <div className="col-md-6 left-section d-none d-md-flex">
            <img src={logo} alt="Logo Union des Comores" />
        </div>

        {/* Colonne droite */}
        <div className="col-md-6 right-section d-flex align-items-center justify-content-center">
          <div className="text-center">            
            <div className="logo-container">
              <img src={logo} alt="Logo Union des Comores" className="logo-small" />
            </div>
            <h2>Ministère de l'Agriculture, de la Pêche et de l'Artisanat</h2>
            <p className="text-description">
              {/* Ministère de l'Agriculture, de la Pêche et de l'Artisanat */}
            </p>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="email"
                className="form-control"
                placeholder="Nom d'utilisateur"
                value={formUser.email}
                onChange={handleChange}
                required
              />
              <div style={{ position: "relative", width: "100%" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control"
                  placeholder="Mot de passe"
                  value={formUser.password}
                  onChange={handleChange}
                  required
                  style={{ paddingRight: "3.5rem" }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="password-toggle-button"
                  aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                >
                  <i className={showPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                </button>
              </div>

              {errorMessage && (
                <div
                  className="alert alert-danger d-flex justify-content-center align-items-center gap-2 mt-3 shadow-sm py-1"
                  role="alert"
                >
                  <i className="bi bi-exclamation-triangle-fill fs-6"></i>
                  <span className="small">{errorMessage}</span>
                </div>
              )}
              <div>
                <a
                  href="#"
                  className="forgot-password"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowResetPopup(true);
                  }}
                >
                  Mot de passe oublié ?
                </a>

                <ResetPasswordPopup
                  show={showResetPopup}
                  onClose={() => setShowResetPopup(false)}
                />
              </div>
              <div>
                <button type="submit" className="btn-connect" disabled={loading}>
                  Se connecter
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
